import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconSocialTwitterDefault(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={25}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='currentColor'
          d='M8.283 20c7.547 0 11.676-5.773 11.676-10.77q.002-.244-.008-.487A8 8 0 0 0 22 6.779a8.9 8.9 0 0 1-2.36.598 3.88 3.88 0 0 0 1.808-2.096 8.6 8.6 0 0 1-2.61.915A4.26 4.26 0 0 0 15.846 5c-2.264 0-4.105 1.698-4.105 3.787 0 .295.04.583.104.864-3.41-.155-6.435-1.669-8.46-3.957a3.56 3.56 0 0 0-.552 1.904c0 1.314.729 2.473 1.825 3.153a4.4 4.4 0 0 1-1.857-.473v.052c0 1.83 1.417 3.366 3.29 3.713a4.3 4.3 0 0 1-1.08.133q-.397 0-.77-.067c.521 1.506 2.042 2.599 3.834 2.628a8.68 8.68 0 0 1-5.098 1.624c-.328 0-.656-.015-.976-.052A12.4 12.4 0 0 0 8.283 20'
        />
      </svg>
    </>
  )
}
IconSocialTwitterDefault.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconSocialTwitterDefault
